import * as yup from "yup";

export const getProfileSchema = () => {
  return yup.object().shape({
    firstName: yup.string(),
    secondName: yup.string(),
    lastName: yup.string(),
    birthday: yup.mixed().nullable(),
    mobilePhone: yup.string(),
    email: yup.string(),
  });
};
